import 'library/styles/components/stripe-form.scss';
import React, { Component } from 'react';
import {
  injectStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  PostalCodeElement
} from 'react-stripe-elements';
import PropTypes from 'prop-types';
import SavingButton from 'library/components/saving-button';
import Tooltip from 'library/components/tooltip';

import VisaSvg from 'library/icons/visa.svg';
import AmexSvg from 'library/icons/amex.svg';
import DiscoverSvg from 'library/icons/discover.svg';
import MastercardSvg from 'library/icons/mastercard.svg';
import JcbSvg from 'library/icons/jcb.svg';
import DinersSvg from 'library/icons/diners.svg';

const ElementStyle = {
  base: {
    color: '#fff'
  }
}

const GetBrandIcon = (brand) => {
  switch (brand) {
    case 'visa':
      return <VisaSvg />;
    case 'diners':
      return <DinersSvg />;
    case 'discover':
      return <DiscoverSvg />;
    case 'mastercard':
      return <MastercardSvg />;
    case 'amex':
      return <AmexSvg />;
    case 'jcb':
      return <JcbSvg />;
    default:
      return null;
  }
}

const CardIcon = ({ brand }) => (
  <div className="card-icon">
    { GetBrandIcon(brand) }
  </div>
)

class StripeForm extends Component {
  static defaultProps = {
    handleChange: ()=>{},
    handleComplete: ()=>{},
    setActive: ()=>{},
    setProcessing: ()=>{}
  }

  state = {
    brand: 'unknown'
  }

  handleChange = (e) => {
    this.props.handleChange(e);
  }

  handleCardNumberChange = (e) => {
    this.setState({
      brand: e.brand
    })

    this.handleSetActive('card', e);
  }

  activeFields = {
    card:false,
    expiration:false,
    cvc:false,
    postal: false
  }

  handleSetActive = (name, e) => {
    this.activeFields[name] = !e.empty;

    this.props.setActive(Object.values(this.activeFields).reduce((a,b)=>a||b, false))
  }

  submit = async (e) => {
    e.preventDefault();

    this.props.setProcessing(true);
    this.setState({
      errors: []
    })

    const { token, error } = await this.props.stripe.createToken({
      type: 'card',
      name: this.state.name
    });

    if (error) {
      this.props.setProcessing(false);
        this.setState({
          errors: [
            error.message
          ]
        })
      return console.error(error);
    }

    this.props.onComplete(token);
  }

  renderErrors = (error) => {
    const { errors=[] } = this.state;

    return (
      <div className="stripe-form-errors">
        {
          errors.map(e=>(
            <p key={btoa(e)}>{ e }</p>
          ))
        }
      </div>
    );
  }

  render() {
    const {
      amount,
      email,
      name,
      hasEmail,
      handleChange,
      processing
    } = this.props;
    const {
      brand
    } = this.state;

    return (
      <form onSubmit={this.submit} className="stripe-form">
        {
          hasEmail
            ? null
            : <input onChange={this.handleChange} value={email} placeholder="Email Address" type="email" name="email" />
        }
        <div className="stripe-form-card">
          <div className="stripe-form-card-number">
            <label>
              <CardNumberElement onChange={(e)=>this.handleCardNumberChange(e)} style={ElementStyle} />
              <small>Card Number</small>
            </label>
          </div>
          <div className="stripe-form-card-expiry-csv">
            <div className="stripe-form-card-expiry">
              <label>
                <CardExpiryElement onChange={(e)=>this.handleSetActive('expiration', e)} style={ElementStyle}/>
                <small>Expiration</small>
              </label>
            </div>
            <div className="stripe-form-card-cvc">
              <label>
                <CardCVCElement onChange={(e)=>this.handleSetActive('cvc', e)} style={ElementStyle}/>
                <small>CVC</small>
              </label>
            </div>
          </div>
          <div className="stripe-form-card-footer">
            <input className="stripe-form-card-footer-name" type="text" value={name} onChange={this.handleChange} name="name" placeholder="Cardholder Name" required />
            <CardIcon brand={brand} />
          </div>
        </div>
        <div className="stripe-form-input">
          <PostalCodeElement onChange={(e)=>this.handleSetActive('postal', e)} />
        </div>
        {
          this.renderErrors()
        }
        <SavingButton type="submit" saving={processing} className="button-tertiary">PAY ${(amount/100).toFixed(2)}</SavingButton>
      </form>
    );
  }
}

export default injectStripe(StripeForm);
